// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"gD-z","smallCardRow":"hD-z","largeCardRow":"iD-z","productSearchRow":"jD-z","curatedRow":"kD-z"};